import { api } from "./api";

const META = process.env.REACT_APP_META_PIXEL_ID;
const TABOOLA = process.env.REACT_APP_TABOOLA_ID;
const GA4 = process.env.REACT_APP_GA4_ID;

const sessionId = (() => {
  try {
    let s = sessionStorage.getItem("fm_sid");
    if (!s) {
      s = Math.random().toString(36).slice(2) + Date.now().toString(36);
      sessionStorage.setItem("fm_sid", s);
    }
    return s;
  } catch {
    return null;
  }
})();

const visitorId = (() => {
  try {
    let v = localStorage.getItem("fm_vid");
    if (!v) {
      v = Math.random().toString(36).slice(2) + Date.now().toString(36);
      localStorage.setItem("fm_vid", v);
    }
    return v;
  } catch {
    return null;
  }
})();

const cachedCountry = () => {
  try { return JSON.parse(localStorage.getItem("fm_country") || "{}").c || undefined; } catch { return undefined; }
};

const addScript = (src) => {
  const s = document.createElement("script");
  s.async = true;
  s.src = src;
  document.head.appendChild(s);
};

export const initPixels = () => {
  if (window.__fmPixels) return;
  window.__fmPixels = true;
  if (META) {
    /* eslint-disable */
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];}(window,document);
    /* eslint-enable */
    addScript("https://connect.facebook.net/en_US/fbevents.js");
    window.fbq("init", META);
  }
  if (GA4) {
    addScript(`https://www.googletagmanager.com/gtag/js?id=${GA4}`);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", GA4, { send_page_view: false });
  }
  if (TABOOLA) {
    window._tfa = window._tfa || [];
    addScript(`https://cdn.taboola.com/libtrc/unip/${TABOOLA}/tfa.js`);
  }
};

const META_MAP = { page_view: "PageView", view_item: "ViewContent", begin_checkout: "InitiateCheckout", generate_lead: "Lead" };
const TABOOLA_MAP = { page_view: "page_view", view_item: "view_content", add_to_cart: "add_to_cart", begin_checkout: "start_checkout", generate_lead: "lead" };

const taboola = (name, props) => {
  const tName = TABOOLA_MAP[name];
  if (!TABOOLA || !window._tfa || !tName) return;
  const ev = { notify: "event", name: tName, id: Number(TABOOLA) };
  if (props.value) Object.assign(ev, { revenue: Number(props.value), currency: props.currency || "CHF" });
  if (tName === "page_view") ev.item_url = window.location.href;
  window._tfa.push(ev);
};

export const track = (name, props = {}) => {
  initPixels();
  try {
    if (META && window.fbq) {
      const std = META_MAP[name];
      std ? window.fbq("track", std, props) : window.fbq("trackCustom", name, props);
    }
    if (GA4 && window.gtag) window.gtag("event", name, props);
    taboola(name, props);
  } catch {
    /* pixels must never break the page */
  }
  api?.post("/events", {
    name, session_id: sessionId, visitor_id: visitorId, country: cachedCountry(),
    path: window.location.pathname, props, utm: getUtm(),
  }).catch(() => {});
};

export const getUtm = () => {
  try {
    const q = new URLSearchParams(window.location.search);
    const keys = ["source", "medium", "campaign", "content", "term"];
    const fresh = Object.fromEntries(keys.map((k) => [k, q.get(`utm_${k}`)]).filter(([, v]) => v));
    if (q.get("tblci")) fresh.tblci = q.get("tblci");
    if (Object.keys(fresh).length) localStorage.setItem("fm_utm", JSON.stringify(fresh));
    return JSON.parse(localStorage.getItem("fm_utm") || "{}");
  } catch {
    return {};
  }
};
